import { API } from 'common/constants/urls';
import { get } from '../../common/axiosClient';
import { InvoiceHistoryDTO } from './invoice.type';

export const getInvoiceHistory = async (invoiceId: string) => (await get(`${API.INVOICES}/${invoiceId}/history`)) as InvoiceHistoryDTO[];
